@if (!allZeroData) {
  <div id="divChart" class="chart-container">
    <canvas id="admissionsAndDischarges"> </canvas>
  </div>
}
